var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-8"},[_c('modal-loading',{class:'full-modal',staticStyle:{"width":"10em"},attrs:{"openModal":true,"value":0,"background_img":`img/janoo-icon-high-color.png`,"label":'... '}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }